import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  ondcReturnOrdersList,
  editReturnOrder,
  getType
} from "../../actions/orderActions";
import DataGrid from "../../components/Datagrid";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";

const OndcReturnRequest = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [statusOptions, setStatusOptions] = useState([]); // list from backend
  const [status, setStatus] = useState(""); // selected status

  // state for dialog
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
const businessInfo = useSelector((state) => state?.app?.businessInfo);
  const customerId = businessInfo?.customerId;
  // const statusOptions = ["Pending", "Processing", "Completed", "Failed"];

  const redirect = (row) => {
    navigate(`/app/management/ondc-order-return-details`, { state: { row } });
  };

  const handleEditClick = (row) => {
    setSelectedRow(row);
    setStatus(row.settlementStatus || "");
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setStatus("");
  };

  const handleSave = () => {
    if (!selectedRow) return;

    const payload = { ondcOrderId: selectedRow.ondcOrderId, status: status , customerId:customerId};
    dispatch(editReturnOrder(payload));
    // dispatch your update API call here
    // e.g., dispatch(updateSettlementStatus(selectedRow._id, status))

    // console.log("Saving for:", selectedRow._id, "New status:", status);

    handleCloseDialog();
  };
 useEffect(() => {
    const fetchStatus = async () => {
      try {
        const result = await dispatch(getType());
        // assuming result is an array like ["Pending","Processing","Completed"]
        console.log("status result:", result);

        if (Array.isArray(result)) {
          setStatusOptions(result);
        }
      } catch (error) {
        console.error("Error fetching status:", error);
      }
    };

    fetchStatus();
  }, [dispatch]);
  ////////=======================================================================//////////
const columns = [
//   { field: "_id", headerName: "ID", width: 220 }, // MongoDB _id

//   {
//     field: "ondcOrderId",
//     headerName: "ONDC Order ID",
//     width: 250,
//     valueGetter: ({ row }) => row?.ondcOrderId || "-",
//   },
//   {
//     field: "transactionId",
//     headerName: "Transaction ID",
//     width: 250,
//     valueGetter: ({ row }) => row?.transactionId || "-",
//   },
  {
    field: "customerName",
    headerName: "Customer Name",
    valueGetter: ({ row }) => row?.order?.billing?.name || "-",
    flex: 1,
  },
  {
    field: "customerPhone",
    headerName: "Phone",
    valueGetter: ({ row }) => row?.order?.billing?.phone || "-",
    flex: 1,
  },
  {
    field: "customerEmail",
    headerName: "Email",
    valueGetter: ({ row }) => row?.order?.billing?.email || "-",
    flex: 1,
  },
  {
    field: "itemName",
    headerName: "Item",
    valueGetter: ({ row }) =>
      row?.order?.quote?.breakup?.[0]?.title || "-",
    flex: 1,
  },
  {
    field: "amount",
    headerName: "Amount",
    valueGetter: ({ row }) =>
      `${row?.order?.quote?.price?.currency || ""} ${
        row?.order?.quote?.price?.value || "-"
      }`,
    flex: 1,
  },
  {
    field: "status",
    headerName: "Status",
    valueGetter: ({ row }) => row?.order?.state || "-",
    flex: 1,
  },
  {
    field: "createdAt",
    headerName: "Created At",
    valueGetter: ({ row }) =>
      row?.createdAt ? new Date(row?.createdAt).toLocaleString() : "-",
    flex: 1,
  },
  {
    field: "updatedAt",
    headerName: "Updated At",
    valueGetter: ({ row }) =>
      row?.updatedAt ? new Date(row?.updatedAt).toLocaleString() : "-",
    flex: 1,
  },
  {
    field: "action",
    headerName: "Action",
    renderCell: (params) => (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Tooltip title="View details">
          <Box
            sx={{ cursor: "pointer" }}
            onClick={() => redirect(params.row)}
          >
            <RemoveRedEyeRoundedIcon />
          </Box>
        </Tooltip>
        <Tooltip title="Edit settlement">
          <Box
            sx={{ cursor: "pointer" }}
            onClick={() => handleEditClick(params.row)}
          >
            <EditIcon />
          </Box>
        </Tooltip>
      </Box>
    ),
    flex: 1,
  },
];



  
  
 
const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);
console.log("orders2", orders)
 useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await dispatch(ondcReturnOrdersList(customerId));
        setOrders(response); // save API response in state
      } catch (err) {
        setError(err.message || "Something went wrong");
      }
    };

    fetchOrders();
  }, [dispatch]);

  return (
    <Box
      sx={{
        maxWidth: "100%",
        padding: 4,
        borderRadius: 2,
        margin: "auto",
        marginTop: 4,
        backgroundColor: "#fff",
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h3" color="textPrimary">
            ONDC Return Request
          </Typography>
        </Grid>

        <Grid item xs={12} sx={{ mt: 2 }}>
          <DataGrid
            col={columns}
            data={orders}
            getRowId={(row) => row?._id}
            name=""
          />
        </Grid>
      </Grid>

      {/* Edit Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TextField
              label="Order Id"
              value={selectedRow?.ondcOrderId || ""}
              fullWidth
              disabled
              sx={{ mb: 3 }}
            />

            <Autocomplete
              options={statusOptions} // from backend
              value={status}
              onChange={(event, newValue) => setStatus(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Type" fullWidth />
              )}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default OndcReturnRequest;
